import React from "react";
import * as yup from "yup";
import Swal from "sweetalert2";
import AppForm from "../../../../../partials/content/Forms/AppForm";
import VisitScheduleFormContent from "./VisitScheduleFormContent";
import { DialogActions } from "@material-ui/core";
import { saveSalesVisit } from "../../../../../services/crm/salesJourney";
import { DateTime } from "luxon";
const visitScheduleSchema = () => {
  return yup.object().shape({
    ID: yup.number(),
    journeyID: yup.number(),
    customerID: yup.number(),
    leadID: yup.number(),
    salesCardID: yup.number(),
    salesCardTitle: yup.string(),
    planVisitDate: yup.date(),
    journeyTitle: yup.string().required("Journey is required"),
    visitActivities: yup.array().of(
      yup.object().shape({
        ID: yup.number(),
        visitID: yup.number(),
        activityID: yup.number().min(1, "Activity is required"),
        statusID: yup.number().min(1, "Status is required"),
        note: yup.string(),
        tasks: yup.array().of(
          yup.object().shape({
            ID: yup.number(),
            title: yup.string(),
            description: yup.string(),
            deadlineDate: yup.date(),
          })
        ),
        dsSetup: yup.bool(),
        deleteInd: yup.bool(),
      })
    ),
  });
};
function VisitScheduleForm({
  journeyID = 0,
  salesCardID = 0,
  customerID = 0,
  leadID = 0,
  onCloseDialog,
  onConfirmSave,
}) {
  return (
    <AppForm
      headSubmitButton={true}
      initialValues={{
        ID: 0,
        journeyID,
        journeyTitle: "",
        visitTo: "",
        customerID,
        leadID,
        salesCardID,
        salesCardTitle: "",
        planVisitDate: DateTime.now().endOf("day"),
        description: "",
        visitActivities: [],
      }}
      validationSchema={visitScheduleSchema}
      onSubmit={async (values, { setStatus, setSubmitting }) => {
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title: "Are you sure want to save this Visit Schedule ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              saveSalesVisit(values).then((response) => {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Saved",
                  html: response.data.message,
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
                onConfirmSave();
              });
            }
          });
      }}
    >
      <VisitScheduleFormContent />
      <DialogActions>
        <button
          type="button"
          className="btn btn-label-danger btn-md btn-pill btn-bold"
          onClick={() => {
            onCloseDialog();
          }}
        >
          <i className="fas fa-window-close"></i>
          Close
        </button>
        <button
          type="submit"
          className="btn btn-success btn-md btn-pill btn-bold"
          onClick={() => {}}
        >
          <i className="fas fa-save"></i>
          Save
        </button>
      </DialogActions>
    </AppForm>
  );
}

export default VisitScheduleForm;
